import types from "./types";

export const fetchSubscriptionCardInfo = (payload) => ({
    type: types.GET_SUBSCRIPTION_CARD_INFO, payload
})
export const fetchSubscriptionCardInfoRes = (payload) => ({
    type: types.GET_SUBSCRIPTION_CARD_INFO_RES, payload
})
export const fetchSubscriptionCardInfoClear = () => ({
    type: types.GET_SUBSCRIPTION_CARD_INFO_CLEAR
})

export const updateSubscriptionCardInfo = (payload) => ({
    type: types.UPDATE_SUBSCRIPTION_CARD_INFO, payload
})
export const updateSubscriptionCardInfoRes = (payload) => ({
    type: types.UPDATE_SUBSCRIPTION_CARD_INFO_RES, payload
})
export const updateSubscriptionCardInfoClear = () => ({
    type: types.UPDATE_SUBSCRIPTION_CARD_INFO_CLEAR
})

export const setPaymentMethodDetail = (payload) => ({
    type: types.PAYMENT_METHOD_DETAIL, payload
})
export const setPaymentMethodDetailClear = () => ({
    type: types.PAYMENT_METHOD_DETAIL_CLEAR
})